import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgBigInfoError = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="60"
        viewBox="0 0 60 60"
        width="60"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect fill="#FDEEEE" height="60" rx="30" width="60" />
        <path
            clipRule="evenodd"
            d="M30.0002 22.6069C30.7461 22.6069 31.3508 23.2116 31.3508 23.9576L31.3461 24.0698L30.7902 30.7413C30.7585 31.1217 30.4405 31.4143 30.0588 31.4143H29.9415C29.5598 31.4143 29.2418 31.1217 29.2101 30.7413L28.6542 24.0698C28.5922 23.3264 29.1446 22.6735 29.888 22.6116C29.9253 22.6085 29.9627 22.6069 30.0002 22.6069Z"
            fill="#C91C1C"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M30 33.4297C30.6804 33.4297 31.232 33.9813 31.232 34.6616C31.232 35.342 30.6804 35.8936 30 35.8936C29.3196 35.8936 28.7681 35.342 28.7681 34.6616C28.7681 33.9813 29.3196 33.4297 30 33.4297Z"
            fill="#C91C1C"
            fillRule="evenodd"
        />
        <path
            d="M30.0032 13.0005C31.178 13.0014 32.1638 13.7279 32.8102 14.7737L45.4873 35.283L45.6313 35.528C46.3181 36.7587 46.52 38.1093 45.8872 39.249C45.2115 40.4659 43.8304 40.9991 42.3101 40.9991H17.693C16.1745 40.9991 14.7918 40.4689 14.1148 39.2523C13.4379 38.036 13.7143 36.5796 14.5158 35.283L27.1929 14.7737L27.3181 14.5803C27.9647 13.6371 28.9014 12.9997 30.0032 13.0005ZM30.0021 15.2505C29.8573 15.2504 29.5673 15.3265 29.2462 15.7515L29.1067 15.9569L16.4296 36.4662C15.8617 37.385 15.9526 37.9284 16.0802 38.1581C16.2078 38.3873 16.6202 38.7491 17.693 38.7491H42.3101C43.3805 38.7491 43.7927 38.3874 43.9207 38.157C44.0332 37.9542 44.1158 37.5115 43.7559 36.7914L43.5735 36.4662L30.8964 15.9569C30.5229 15.3526 30.1685 15.2508 30.0021 15.2505Z"
            fill="#C91C1C"
        />
    </svg>
);

export const BigInfoErrorIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgBigInfoError}
        fontSize={fontSize}
    />
);
